import { useSelector } from 'react-redux';
import { store } from '../../store';
import type { RootState } from '../../store';

function selectUserId(s: RootState): string | null {
  return s.ssoUser?.profile?.sub ?? s.user?.session?.username?.trim() ?? null;
}

function selectUsername(s: RootState): string | null {
  return s.user?.session?.username?.trim() ?? null;
}

export function getCurrentUserId(): string | null {
  return selectUserId(store.getState());
}

export function useCurrentUserId(): string | null {
  return useSelector(selectUserId);
}

export function useCurrentUsername(): string | null {
  return useSelector(selectUsername);
}

export function getCurrentUserDisplayName(): string {
  const ssoProfile = store.getState().ssoUser?.profile;
  if (ssoProfile?.name) return ssoProfile.name;
  if (ssoProfile?.given_name || ssoProfile?.family_name) {
    return `${ssoProfile.given_name ?? ''} ${ssoProfile.family_name ?? ''}`.trim();
  }
  return getCurrentUserId() ?? '';
}

export function getCurrentUserEmail(): string {
  return store.getState().ssoUser?.profile?.email ?? '';
}

export function getCurrentUserInitials(): string {
  const ssoProfile = store.getState().ssoUser?.profile;
  if (ssoProfile?.given_name && ssoProfile?.family_name) {
    return (ssoProfile.given_name[0] + ssoProfile.family_name[0]).toUpperCase();
  }
  const value = getCurrentUserDisplayName().trim();
  if (!value) return 'U';
  const parts = value.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
